import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { branding, domain, shortBranding } from '../../../common/text';

import * as emails from 'common/emails.json';

declare const GAMING: boolean;

const siteNames = Object.values(domain).map(x => x.toLowerCase())

@Component({
  selector: 'privacy-policy-page',
  styleUrls: ['./privacy-policy-page.component.scss'],
  templateUrl: './privacy-policy-page.component.pug'
})
export class PrivacyPolicyPage implements OnInit {
  public brand: string = branding[GAMING ? 'gaming' : 'pfm'];
  public abv: string = shortBranding[GAMING ? 'gaming' : 'pfm']
  public sites: string = (GAMING ? [...siteNames].reverse() : [...siteNames]).join(', ')
  public dataPrivacy: string = emails.dataPrivacy;
  public event: string = GAMING ? 'event' : 'screening'
  public anEvent: string = GAMING ? 'an event' : 'a screening'
  public events: string = GAMING ? 'events' : 'screenings'
  public eventType: string = GAMING ? 'creative content event' : 'movie screening'
  public eventTypes: string = GAMING ? 'events, playtests' : 'movie previews, screenings'

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  public ngOnInit() {
    this.titleService.setTitle(`${this.brand} - Privacy Policy`);
  }
}
